import { ApiRequest, RequestMethod } from "../../request";

export async function addSkill(
  fighterId: string,
  skillId: string,
  isBuiltIn: boolean,
  experienceToSpend: number
): Promise<boolean> {
  const apiRequest = new ApiRequest();

  const URL = `/api/fighter/${fighterId}/add-skill`;

  apiRequest.setMethod(RequestMethod.POST);
  apiRequest.setUrl(URL);

  apiRequest.setJsonBody({
    skillId: skillId,
    isBuiltIn: isBuiltIn,
    experienceToSpend: experienceToSpend
  });

  try {
    const response: any = await apiRequest.send();
    return response.status === 200;
  } catch (error) {
    console.error("Error adding skill:", error);
    return false;
  }
}